const grabValues = array => array.map(item => item.value);

export default grabValues;
